(function (Lfl, $, undefined) {
    /**
     * @memberOf Lfl
     */
    Lfl.Typography = Lfl.Typography || {};

    (function (Typography, $, undefined) {
        if (Lfl.Files.isLoadedAlready(Lfl.Typography, 'CzechTypographyHandler')) {
            return;
        }

        /*
         |==============================================================================================================
         | Documentation
         |==============================================================================================================
         */

        /**
         * Handles czech typography.
         *
         * @memberOf Lfl.Typography
         */
        Lfl.Typography.CzechTypographyHandler = Typography.CzechTypographyHandler || {};

        (function (CzechTypographyHandler, $, undefined) {
            /*
             |==========================================================================================================
             | Object definition 
             |==========================================================================================================
             */

            /*
             |----------------------------------------------------------------------------------------------------------
             | Public methods
             |----------------------------------------------------------------------------------------------------------
             */

            CzechTypographyHandler.init = function () {
                var $text = $('p, span');

                // mezery za předložkami a zkratkami
                $text.each(function () {
                    var str = $(this).html();
                    str = str.replace(/(\s)(a|i|k|ke|ku|o|ó|s|u|v|ve|z|za|ze|od|do|na|nad|po|pod|pro|při|že|např.|tzn.|tzv.|mj.|č.|cca)(\s+)/gmi, '$1$2&nbsp;');
                    $(this).html(str);
                });

                // mezery mezi skupinou čísel
                $text.each(function () {
                    var str = $(this).html();
                    str = str.replace(/(\d)(\s+)(\d)/gu, '$1&nbsp;$3');
                    $(this).html(str);
                });

                // mezery mezi číslem a jednotkou
                $text.each(function () {
                    var str = $(this).html();
                    str = str.replace(/(\d)(\s)(mm|cm|m|m2|km|g|dkg|kg|t|h|hod|ml|l|Kč)/gmi, '$1&nbsp;$3');
                    $(this).html(str);
                });

                // mezery mezi řadovým číslem a následným textem
                $text.each(function () {
                    var str = $(this).html();
                    str = str.replace(/(\d)(\.)(\s+)([a-z])/gm, '$1$2&nbsp;$4');
                    $(this).html(str);
                });
            }

        }(Typography.CzechTypographyHandler, jQuery));
    }(Lfl.Typography, jQuery));
}(window.Lfl = window.Lfl || {}, jQuery));